(function () {
	// Carousels are Swiper Elements that set themselves up from their attributes (W4D_UI_Components::render_carousel_attrs
	// in the plugin), also when they arrive over AJAX. What is left here is the page-level glue around them.

	// A native drag of a link or an image would take over a swipe done with the mouse
	document.addEventListener('dragstart', (e) => {
		if (e.target.closest?.('swiper-container')) {
			e.preventDefault();
		}
	});

	// The related products stay behind their loader until the carousel is laid out
	customElements.whenDefined('swiper-container').then(() => {
		document.getElementById('w4d-related-products-section')?.classList.remove('init-is-loading');
	});

	// Content product cards use container queries for their widths. Resolve steps from that visible count,
	// including hidden tabs, resized containers and carousels inserted over AJAX. Wait until Swiper's own update
	// has finished so breakpoint defaults cannot overwrite the measured step.
	const pendingSteps = new WeakSet();
	const settleProductStep = (carousel) => {
		if (!carousel?.hasAttribute('data-carousel-slides-per-group') || pendingSteps.has(carousel)) return;
		pendingSteps.add(carousel);
		requestAnimationFrame(() => {
			pendingSteps.delete(carousel);
			const swiper = carousel.swiper;
			if (!swiper || swiper.destroyed || swiper.params.slidesPerView !== 'auto') return;
			const visible = Number.parseInt(getComputedStyle(carousel).getPropertyValue('--carousel-per-view'), 10);
			const setting = carousel.dataset.carouselSlidesPerGroup;
			const requested = setting === 'view' ? visible : Number.parseInt(setting, 10);
			if (!(visible > 0) || !(requested > 0)) return;
			const step = Math.min(requested, visible);
			if (swiper.params.slidesPerGroup === step && !swiper.params.slidesPerGroupAuto) return;
			swiper.params.slidesPerGroup = step;
			swiper.params.slidesPerGroupAuto = false;
			swiper.update();
		});
	};

	['swiperinit', 'swiperresize', 'swiperupdate', 'swiperbreakpoint'].forEach((event) => {
		document.addEventListener(event, (e) => settleProductStep(e.target));
	});
	customElements.whenDefined('swiper-container').then(() => {
		document.querySelectorAll('swiper-container').forEach(settleProductStep);
	});
	// Viewport breakpoints can change card widths even when the container itself has not resized.
	window.addEventListener('resize', () => {
		document.querySelectorAll('swiper-container[data-carousel-slides-per-group]').forEach((carousel) => {
			carousel.swiper?.update();
		});
	});

	// Autoplay (banner, logotypes) moves content on its own. Without a play/pause button of its own
	// ([data-autoplay-toggle], the banner) it does not run for prefers-reduced-motion, and it holds while keyboard
	// focus (:focus-visible, so not the focus a click or tap leaves on an arrow or dot) is inside the carousel, so a
	// focused link, arrow or dot does not slide away. The play/pause button itself ([data-autoplay-toggle]) does not
	// hold it. Swiper resumes on its own after a slide change or when the mouse leaves; the resume event puts the
	// hold back while focus is still inside.
	const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)');

	// Stopped here for reduced motion, started again when the preference is turned off
	const stoppedForMotion = new WeakSet();

	const holdsFocus = (carousel, focused) =>
		focused instanceof Element &&
		carousel.contains(focused) &&
		focused.matches(':focus-visible') &&
		!focused.closest('[data-autoplay-toggle]');

	const settleAutoplay = (carousel) => {
		const autoplay = carousel?.swiper?.autoplay;
		if (!autoplay?.running) return;

		if (reducedMotion?.matches && !carousel.querySelector('[data-autoplay-toggle]')) {
			stoppedForMotion.add(carousel);
			autoplay.stop();
		} else if (holdsFocus(carousel, document.activeElement) && !autoplay.paused) {
			autoplay.pause();
		}
	};

	// Focus moved to an element that does not hold autoplay (outside, or the play/pause button)
	const releaseFocusHold = (carousel, focused) => {
		const autoplay = carousel?.swiper?.autoplay;

		if (!autoplay?.running || !autoplay.paused || holdsFocus(carousel, focused) || carousel.matches(':hover')) return;

		autoplay.resume();
	};

	const carouselOf = (e) => (e.target instanceof Element ? e.target.closest('swiper-container') : null);

	document.addEventListener('swiperautoplaystart', (e) => settleAutoplay(e.target));
	document.addEventListener('swiperautoplayresume', (e) => settleAutoplay(e.target));
	document.addEventListener('focusin', (e) => {
		settleAutoplay(carouselOf(e));
		releaseFocusHold(carouselOf(e), e.target);
	});
	document.addEventListener('focusout', (e) => {
		const carousel = carouselOf(e);
		if (carousel && !carousel.contains(e.relatedTarget)) releaseFocusHold(carousel, e.relatedTarget);
	});

	// The preference changed mid-page
	reducedMotion?.addEventListener('change', () => {
		document.querySelectorAll('swiper-container').forEach((carousel) => {
			const autoplay = carousel.swiper?.autoplay;

			if (reducedMotion.matches) {
				settleAutoplay(carousel);
			} else if (stoppedForMotion.has(carousel)) {
				stoppedForMotion.delete(carousel);
				if (autoplay && !autoplay.running) autoplay.start();
			}
		});
	});

	// Carousels already set up before this ran (their autoplay start event was missed)
	customElements.whenDefined('swiper-container').then(() => {
		document.querySelectorAll('swiper-container').forEach(settleAutoplay);
	});
})();
